import { Formik } from "formik";
import Loader from "../../loader";
import TagInput from "../../form/TagInput";
import StepsDots from "../../form/StepsDots";
import ErrorMessage from "../../form/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import PdfOrImageUploader from "../../pdfImage uploader";
import { profileStep2Schema } from "../../../utils/schema";
import { setRegisterStep } from "../../../redux/features/find-a-job/reducers/authReducer";
import { profileStep2Submit } from "../../../redux/features/find-a-job/actions/authAction";
import {
  getFreelancerFormData,
  updateFreelancerFormData,
} from "../../../utils/pip";

const ProfileSetupStep2 = ({ stepBack }) => {
  const dispatch = useDispatch();
  const { subLoading } = useSelector((state) => state.freelancer.auth);
  const savedData = getFreelancerFormData()?.profileStep2 || {};

  const handleStep2 = (values) => {
    const callback = (res) => {
      if (res?.success) {
        updateFreelancerFormData("profileStep2", {
          ...values,
          certificates: values.certificates.map((f) =>
            f instanceof File
              ? { name: f.name, type: f.type, preview: URL.createObjectURL(f) }
              : f
          ),
        });
        dispatch(setRegisterStep("profileStep3"));
      }
    };

    const formData = new FormData();
    formData.append("skills", values?.skills?.join(","));
    formData.append("language", values?.language);
    // (values.certificates || []).forEach((file) => {
    //   formData.append("certificates", file);
    // });

    // Append only REAL File objects
    (values.certificates || [])
      .filter((file) => file instanceof File)
      .forEach((file) => {
        formData.append("certificates", file);
      });

    dispatch(profileStep2Submit({ payload: formData, callback }));
  };

  if (subLoading) {
    return <Loader />;
  }
  return (
    <div class="modal-body pe-0">
      <section class="ct_signup_main py-3">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
              <div class="ct_signup_left_img">
                <img
                  src="../assets/img/faq_img.png"
                  alt=""
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0 ">
              <div class="ct_signup_right_content px-5 ct_custom_scroll">
                {/* <div
                  className="ct_back_top_btn"
                  onClick={() => {
                    dispatch(setRegisterStep("profileStep1"));
                  }}
                >
                  <i class="fa-solid fa-arrow-left"></i>
                </div> */}
                <div class="ct_signup_logo ct_mb_34">
                  <img src="../assets/img/Nuvio_logo.png" alt="" />
                </div>
                <div class="mt-0 text-center">
                  <h2 class="ct_fs_32  mb-0 ct_darkblue_text">
                    Share Your Technical Skills
                  </h2>
                  <p className="mb-0 ct_fs_16 mt-2 ct_darkblue_text mx-auto">
                    Let us know what you’re great at so we can tailor
                    opportunities to your strengths.
                  </p>
                </div>
                <Formik
                  initialValues={savedData}
                  validationSchema={profileStep2Schema}
                  onSubmit={(values, actions) => {
                    handleStep2(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    setTouched,
                  }) => (
                    <form onSubmit={handleSubmit} class="ct_mt_40">
                      <div className="row">
                        <TagInput
                          label="Skills"
                          placeholder="Type to add skills..."
                          name="skills"
                          value={values.skills}
                          onChange={setFieldValue}
                          error={touched.skills && errors.skills}
                        />

                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label class="mb-2 d-block ct_darkblue_text ct_fs_14">
                              {" "}
                              Certificates (Optional){" "}
                            </label>
                            <PdfOrImageUploader
                              maxFiles={20}
                              multiple={true}
                              acceptType="application/pdf,image/*"
                              placeholder="Upload Certificates (PDF or Image)"
                              existingFiles={
                                values?.certificates &&
                                  Array.isArray(values.certificates)
                                  ? values.certificates.map((file, idx) => {
                                    const isString = typeof file === "string";
                                    const isFileObj = file instanceof File;

                                    return {
                                      id: idx,
                                      file: isString
                                        ? file
                                        : file.preview
                                          ? file.preview
                                          : URL.createObjectURL(file),

                                      name:
                                        file.name || `certificates-${idx}`,

                                      // Detect type correctly
                                      type: isString
                                        ? file.endsWith(".pdf")
                                          ? "pdf"
                                          : "image"
                                        : file.type?.includes("pdf")
                                          ? "pdf"
                                          : file.type?.includes("zip")
                                            ? "zip"
                                            : "image",

                                      preview: file.preview || null, // 🔥 keep preview if exists
                                      isExisting: true,
                                    };
                                  })
                                  : []
                              }
                              onChange={(newFiles) => {
                                setTouched({ certificates: true });
                                setFieldValue("certificates", newFiles); // store array of files
                              }}
                            />

                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName={"certificates"}
                            />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label class="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              Language
                            </label>
                            <input
                              class="form-control ct_input"
                              placeholder="Language"
                              type="text"
                              id="language"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.language}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName={"language"}
                            />
                          </div>
                        </div>
                      </div>
                      <div class="text-center mt-2">
                        <button
                          type="submit"
                          onClick={handleSubmit}
                          class="ct_yellow_btn w-100 mx-auto"
                        >
                          Continue
                        </button>
                      </div>
                      <StepsDots steps={[1, 2, 3, 4]} activeStep={2} />
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProfileSetupStep2;
